export const I18nActions = {
    FETCH_I18N: 'FETCH_I18N',
    SET_I18N: 'SET_I18N'
};

export const mutations = {
    [I18nActions.SET_I18N](state, payload) {
        state.i18n = payload;
    }
};
